import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { InputFieldComponent } from '../../../../components/form/input-field/input-field.component';
import { TextAreaFieldComponent } from '../../../../components/form/textarea-field/textarea-field.component';
import { MeetingMinuteRowsBase } from '../meeting-minute-rows/meeting-minute-rows.base';

import { ConfirmationDialogService } from '../../../../services/confirmation-dialog.service';

@Component({
  selector: 'meeting-minute-next-meetings',
  imports: [ReactiveFormsModule, InputFieldComponent, TextAreaFieldComponent],
  templateUrl: './meeting-minute-next-meetings.component.html',
  styleUrl: '../meeting-minute-rows/meeting-minute-rows.scss'
})
export class MeetingMinuteNextMeetingsComponent extends MeetingMinuteRowsBase {

  protected readonly idControlName = 'meetingMinuteNextId';
  protected readonly rowLabel = 'next meeting';

  constructor(confirmationDialogService: ConfirmationDialogService) {
    super(confirmationDialogService);
  }
}
